import { cardsItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-article-line"></i>
            最新资讯
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门图文资讯
          </h2>
          <p className="text-sm text-foreground-500 mt-2">最新最热的吃瓜资讯一手掌握</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-[10px] font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap">{item.date}</span>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
                <div className="flex items-center gap-1 mt-3 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}